var _rect, _rect2, _rect3, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFpgaChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "FPGA board icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#f2f7ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#1267d7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1267d7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 31,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 40,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 22,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 31,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 40,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 3,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 2,
    width: 3,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 2,
    width: 3,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 54,
    width: 3,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 54,
    width: 3,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 54,
    width: 3,
    height: 8,
    rx: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 60,
    textAnchor: "middle",
    fontSize: 8,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fill: "#114fa8"
  }, "FPGA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpgaChip);
export default __webpack_public_path__ + "static/media/fpga-chip.de4780ca369f0f0e77a972218b05375f.svg";
export { ForwardRef as ReactComponent };